import React, { Component } from 'react';
import PropTypes from 'prop-types';
import enhanceWithClickOutside from 'react-click-outside';
import { Button, Tooltip, OverlayTrigger } from 'react-bootstrap';

class ConfirmButton extends Component {
  constructor() {
    super();
    this.state = {
      confirm: false,
    };
    this.showConfirm = this.showConfirm.bind(this);
    this.confirm = this.confirm.bind(this);
  }

  showConfirm() {
    this.setState({ confirm: true });
    this.props.onConfirmActive(true);
  }

  confirm() {
    this.props.onConfirm();
    this.setState({ confirm: false });
    this.props.onConfirmActive(false);
  }

  handleClickOutside() {
    this.setState({ confirm: false });
    this.props.onConfirmActive(false);
  }

  render() {
    const {
      confirmStyle, onConfirmStyle, disabled, size, confirmMessage, style,
      tooltip, className,
    } = this.props;
    const { confirm } = this.state;

    const btn = !confirm ? (
      <Button
        type="button"
        disabled={disabled}
        bsSize={size}
        onClick={this.showConfirm}
        bsStyle={confirmStyle}
        style={style}
        className={className}
      >
        {this.props.children}
      </Button>
    ) : (
      <Button
        type="button"
        bsSize={size}
        onClick={this.confirm}
        bsStyle={onConfirmStyle}
        className={className}
      >
        {confirmMessage}
      </Button>
    );
    if (tooltip) {
      const tip = (
        <Tooltip id="confirm-tip">
          <div>{tooltip}</div>
        </Tooltip>
      );
      return (
        <OverlayTrigger key="button" trigger={['hover', 'focus']} placement="top" overlay={tip}>
          {btn}
        </OverlayTrigger>
      );
    }
    return btn;
  }
}

ConfirmButton.propTypes = {
  confirmStyle: PropTypes.string,
  onConfirmStyle: PropTypes.string,
  size: PropTypes.string,
  onConfirm: PropTypes.func,
  onConfirmActive: PropTypes.func,
  disabled: PropTypes.bool,
  children: PropTypes.node,
  confirmMessage: PropTypes.string,
  style: PropTypes.shape({}),
  tooltip: PropTypes.string,
  className: PropTypes.string,
};
ConfirmButton.defaultProps = {
  tooltip: null,
  disabled: false,
  size: null,
  confirmStyle: 'default',
  onConfirmStyle: 'danger',
  confirmMessage: 'Sure?',
  onConfirm: () => {},
  children: null,
  onConfirmActive: () => {},
  style: {},
  className: null,
};

export default enhanceWithClickOutside(ConfirmButton);
